import { render, staticRenderFns } from "./NavigationDropdown.vue?vue&type=template&id=2b023768&"
import script from "./NavigationDropdown.vue?vue&type=script&lang=js&"
export * from "./NavigationDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports